import React, { useState, useMemo, useCallback } from "react";

import { createEditor, Transforms } from "slate";
import { withHistory } from "slate-history";
import {
  Slate,
  Editable,
  withReact,
  useSelected,
  useFocused
} from "slate-react";

import "./styles.css";

const Text = props => {
  const { blockImage } = props;

  const [value, setValue] = useState([
    {
      type: "paragraph",
      children: [{ text: "" }]
    }
  ]);
  const editor = useMemo(() => withHistory(withReact(createEditor())), []);

  let Leaf = ({ attributes, children, leaf }) => {
    if (props.simple) {
      return <span>{children}</span>;
    }

    if (leaf.bold) {
      children = <strong>{children}</strong>;
    }

    if (leaf.italic) {
      children = <em>{children}</em>;
    }

    if (leaf.underline) {
      children = <u>{children}</u>;
    }

    return <span {...attributes}>{children}</span>;
  };

  const renderLeaf = useCallback(props => <Leaf {...props} />, []);

  let Element = props => {
    const { attributes, children, element } = props;

    switch (element.type) {
      case "image":
        return <ImageElement {...props} />;
      default:
        return <div {...attributes}>{children}</div>;
    }
  };

  let SimpleElement = props => {
    const { attributes, children, element } = props;

    switch (element.type) {
      case "image":
        return null;
      default:
        return <span>{children}</span>;
    }
  };

  const renderElement = props => <Element {...props} />;

  const simpleRenderElement = props => <SimpleElement {...props} />;

  return (
    <div className="" style={props.style}>
      <Slate
        editor={editor}
        value={JSON.parse(props.children)}
        onChange={newValue => setValue(newValue)}
      >
        <Editable
          className={props.ellipsis ? "text-ellipsis" : ""}
          readOnly
          renderElement={props.simple ? simpleRenderElement : renderElement}
          renderLeaf={renderLeaf}
        />
      </Slate>
    </div>
  );
};

let ImageElement = ({ attributes, children, element }) => {
  const selected = useSelected();
  const focused = useFocused();
  return (
    <div {...attributes}>
      <div contentEditable={false} className="d-flex justify-content-center">
        <img
          alt=""
          src={element.url}
          className="d-block rounded"
          style={{
            maxWidth: "100%",
            maxHeight: "20em",
            boxShadow: selected && focused ? "0 0 0 3px #B4D5FF" : "none"
          }}
        />
      </div>
      {children}
    </div>
  );
};

export default Text;
